export const API_URL = import.meta.env.VITE_API_URL as string;
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL as string;
export const IS_DEV = import.meta.env.DEV;

/** The API's SSE stream for a realtime channel: a `ping` whenever something in it changed. */
export const realtimeUrl = (channel: string) =>
  `${API_URL}/realtime/${encodeURIComponent(channel)}/sse`;
